// extracted by mini-css-extract-plugin
export default {"section":"style_section__DN5DT","cardBox":"style_cardBox__GHoyf","title":"style_title__BV5Hu","subtitle":"style_subtitle__xyEMn"};